import { useEffect, useRef, useState } from 'react';
import { useMap } from '@/features/map';
import { PitchToggle } from './PitchToggle';
import { createTerrainController, type TerrainController } from './terrainController';
import { useOverlayRefreshOnTerrain } from './useOverlayRefreshOnTerrain';

/** Flat 2D map by default; the 2D/3D map button switches to tilted 3D terrain and back. */
export function TerrainControl() {
  const map = useMap();
  const [is3d, setIs3d] = useState(false);
  const controller = useRef<TerrainController | null>(null);
  useOverlayRefreshOnTerrain();

  useEffect(() => {
    if (!map) return;
    const c = createTerrainController(map);
    controller.current = c;
    return () => {
      c.dispose();
      controller.current = null;
    };
  }, [map]);

  useEffect(() => controller.current?.setEnabled(is3d), [map, is3d]);

  return <PitchToggle is3d={is3d} onToggle={() => setIs3d(!is3d)} />;
}
